
import { granjaApi } from "../../api";
import { useGranjassStore } from "../../store";

import Swal from "sweetalert2";






export const startGranjaXID = async(id) => {
    try {
        const { data } = await granjaApi.get(`/granja/xid/${id}`);
        return data.data;
    } catch (error) {
        Swal.fire('Error', error.response.data.msg, 'error');
        console.log(error)
    }
}





export const startListadoGranjas = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);
        const { data } = await granjaApi.get('/granja', { params });

        useGranjassStore.setState({ totalGranjas: data.total });
        return data.data;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const startSavingGranja = async(granja) => {
    try {
        if( granja.id ){
            await granjaApi.put(`/granja/${ granja.id }`, granja );
            Swal.fire('Exitoso', 'Granja Actualizada', 'success');
        }else {
            await granjaApi.post('/granja/new', granja);
            Swal.fire('Exitoso', 'Granja Creada', 'success');
            return true;
        }
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data.msg, 'error');
        return false;
    }
} 


    
    



    // const deleteGranja = async( granja ) => {
    //     try {
    //         const { data } = await granjaApi.delete(`/granja/${ granja.id }`);
    //         if( data.ok ){
    //             dispatch( onDeleteGranja( data.granja ) );
    //             Swal.fire('Exitoso', 'Granja Eliminada', 'success');
    //         }
    //     } catch (error) {
    //         Swal.fire('Error', error.response.data.msg, 'error');
    //         console.log(error);
    //     }
    // }